import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../assets/text-helpers.scss';

export const templateIntegrityMonitorPolicyRuleSetsSection = document.createElement('template');

templateIntegrityMonitorPolicyRuleSetsSection.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-enum-filter id="rule-sets-selector" labelWidth="240"></gz-enum-filter>
    <gz-grid-view id="rule-sets-grid"></gz-grid-view>
  </div>
`;
